import React from 'react';
import { useIntl } from 'react-intl';
import { uploadEndpointDatasetAttachments } from '@/constants/urls';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import { formatBytes } from '@/utils/fileHelper';
import { downLoadableAttachmentIcon } from '../helper';
import AttachmentTypeFlag from './AttachmentTypeFlag';
import AttachmentToolsMenu from './AttachmentToolsMenu';
import DatasetAttachmentCardItemExtra from './DatasetAttachmentCardItemExtra';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const DatasetAttachmentCardItem = ({
  attachment,
  category,
  code,
  upward,
}) => {
  const intl = useIntl();
  const {
    canDownload, canUpdate, isDownloading, isLoading,
  } = Selectors.useDatasetAttachmentCardItem({ category, code, attachment });
  const downloadStart = Events.useDatasetAttachmentDownload(category, { code });
  const {
    iconName, iconTitle, color, exceedsDownloadSize, warning,
  } = downLoadableAttachmentIcon(attachment, isDownloading);
  const isLink = canDownload && !isDownloading && !exceedsDownloadSize;
  const {
    id, name, size, metadata: { description, transferable, viewing },
  } = attachment;

  return (
    <CardItem className="aridhia-attachment-card-item" warning={canUpdate && warning}>
      <NameDescriptionCard
        description={description}
        href={isLink ? uploadEndpointDatasetAttachments(code, id) : undefined}
        icon={iconName}
        iconColour={color}
        iconMessage={iconTitle}
        loading={isLoading}
        markdown
        meta={intl.formatMessage({ id: 'file.size' }, { size: formatBytes(size, false) })}
        name={name}
        onClick={isLink ? () => downloadStart({ attachment }) : undefined}
        renderSystemFlag={() => <AttachmentTypeFlag attachment={attachment} />}
        system
        withDescriptionShowMore
      >
        <AttachmentToolsMenu
          allowManage
          attachment={attachment}
          category={category}
          code={code}
          iconSize="large"
          listItem
          upward={upward}
        />
      </NameDescriptionCard>
      {canUpdate && (<DatasetAttachmentCardItemExtra transferable={transferable} viewing={viewing} />)}
    </CardItem>
  );
};

export default DatasetAttachmentCardItem;
